import { render, staticRenderFns } from "./createMonthlyReview.vue?vue&type=template&id=ddc26678"
import script from "./createMonthlyReview.vue?vue&type=script&lang=js"
export * from "./createMonthlyReview.vue?vue&type=script&lang=js"
import style0 from "./createMonthlyReview.vue?vue&type=style&index=0&id=ddc26678&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports